(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDashboardDetailController', TabObjectsDashboardDetailController);

    TabObjectsDashboardDetailController.$inject = ['$state', 'entity', 'fleetId', 'objTypeId', '$scope', 'warningDetail', '$rootScope'];

    function TabObjectsDashboardDetailController($state, entity, fleetId, objTypeId, $scope, warningDetail, $rootScope) {
        var vm = this;
        vm.tabObjects = entity;
        vm.grafanaUrl = "";
        vm.frameHeight = 0;
        vm.fleet = {};
        vm.tabObjects.$promise.then(function (res) {
            vm.dashboardType = "techObjectFrame" + res.objectType.objectTypeName.replace(".","");
        });
        vm.objectType = {};
        vm.fleet.id = fleetId;
        vm.objectType.id = objTypeId;
        vm.oldURL = document.baseURI;
        vm.columnChoose = { from: 'now-1h', to: 'now', display: 'Last 1 hour', setDate:function(){setHoursLess(1)}};
        vm.toDate = vm.columnChoose.to;
        vm.fromDate = vm.columnChoose.from;
        vm.toCalendarDate = null;
        vm.fromCalendarDate = null;
        vm.dashboardRange = vm.columnChoose.display;
        vm.warningDetail = warningDetail;
        vm.nextBtnDisabled = 0;
        vm.prevBtnDisabled = false;
        vm.isCustomTimeRange = false;
        vm.licence = $rootScope.licence;

        if (warningDetail.warningName !== '') {
            vm.fromDate = vm.warningDetail.warningDateFrom;
            vm.toDate = vm.warningDetail.warningDateTo;
            vm.dashboardRange = vm.fromDate + " to " + vm.toDate;
        }

        vm.rangeOptions = [
            {
                column1 : { from: 'now/d',    to: 'now/d',    display: 'Today', setDate: function () {setDayLess()}},
                column2 : { from: 'now-2d',   to: 'now',      display: 'Last 2 days', setDate: function () {setDaysLess(2)}},
                column3 : { from: 'now-1h',   to: 'now',      display: 'Last 1 hour', setDate:function(){setHoursLess(1)}},
                column4 : { from: 'now-5m',   to: 'now',      display: 'Last 5 minutes', setDate:function(){setMinutesLess(5)}}
            },
            {
                column1 : { from: 'now-7d/d', to: 'now-7d/d', display: 'This day last week', setDate: function () {setWeekDayLess()}},
                column2 : { from: 'now-7d',   to: 'now',      display: 'Last 7 days', setDate: function () {setDaysLess(7)}},
                column3 : { from: 'now-3h',   to: 'now',      display: 'Last 3 hours', setDate:function(){setHoursLess(3)}},
                column4 : { from: 'now-15m',  to: 'now',      display: 'Last 15 minutes', setDate:function(){setMinutesLess(15)}}
            },
            {
                column1 : { from: 'now/w',    to: 'now/w',    display: 'This week', setDate: function (){setWeekLess()}},
                column2 : { from: 'now-15d',   to: 'now',      display: 'Last 15 days', setDate: function () {setDaysLess(15)}},
                column3 : { from: 'now-6h',   to: 'now',      display: 'Last 6 hours', setDate:function(){setHoursLess(6)}},
                column4 : { from: 'now-30m',  to: 'now',      display: 'Last 30 minutes', setDate:function(){setMinutesLess(30)}}
            },
            {
                column1 : { from: 'now/M',    to: 'now/M',    display: 'This month', setDate: function () {setMonthLess()}},
                column2 : { from: 'now-30d',  to: 'now',      display: 'Last 30 days', setDate: function () {setDaysLess(30)}},
                column3 : { from: 'now-12h',  to: 'now',      display: 'Last 12 hours', setDate:function(){setHoursLess(12)}},
                column4 : { from: 'now-24h',  to: 'now',      display: 'Last 24 hours', setDate:function(){setHoursLess(24)}},
            },
            {
                column1: {from: '', to: '', display: ''},
                column2: {from: '', to: '', display: ''},
                column3: {from: '', to: '', display: ''},
                column4: {from: '', to: '', display: ''}
            }

        ];

        vm.isOpen = false;

        vm.fromDateOptions = {
            minDate: null,
            maxDate: new Date()
        };

        vm.toDateOptions = {
            minDate: new Date(),
            maxDate: getTwoWeeks(new Date(), false)
        };

        //Forces the max value of date-range to two weeks; ensures that fromDate is never bigger than toDate to keep date-range integrity
        vm.onChangeFromDate = function () {
            if (vm.fromCalendarDate) {
                vm.toDateOptions.minDate = vm.fromCalendarDate;
                vm.toDateOptions.maxDate = getTwoWeeks(vm.fromCalendarDate, false);

                if (getTwoWeeks(vm.fromCalendarDate, false) <= vm.toCalendarDate) {
                    vm.toCalendarDate = vm.toDateOptions.maxDate;
                }

                if (vm.toCalendarDate == null || vm.fromCalendarDate >= vm.toCalendarDate)
                    vm.toCalendarDate = new Date(vm.fromCalendarDate.getFullYear(), vm.fromCalendarDate.getMonth(), vm.fromCalendarDate.getDate() + 1);
            } else
                vm.fromCalendarDate = vm.today();

        };

        vm.applyFilterDate = function (e) {
            vm.isCustomTimeRange = true;
            vm.isOpen = !vm.isOpen;
            vm.rangeInMillis = 0;
            vm.fromDate = angular.copy(vm.fromCalendarDate);
            vm.toDate = angular.copy(vm.toCalendarDate);
            vm.fromDate.setMilliseconds(0);
            vm.fromDate.setSeconds(0);
            vm.toDate.setMilliseconds(0);
            vm.toDate.setSeconds(0);
            vm.dashboardRange = vm.fromDate.toString().substring(0, vm.fromDate.toString().indexOf("GMT")) + " to " + vm.toDate.toString().substring(0, vm.toDate.toString().indexOf("GMT"));
            vm.rangeInMillis = Math.abs(vm.fromDate - vm.toDate);
            checkNext();
        };

        function applyDate(from, to) {
            vm.fromDate = from;
            vm.toDate = to;
        }


        // quick range dashboard time, from anything to now
        vm.changeRange = function (column) {
            vm.nextBtnDisabled = 0;
            vm.columnChoose = column
            vm.fromDate = column.from;
            vm.toDate = column.to;
            vm.dashboardRange = column.display;
            vm.isOpen = !vm.isOpen;
            vm.prevBtnDisabled = false;
            vm.isCustomTimeRange = false;
        };

        // Get two weeks before (if "back" flag is set to true) or after the chosen date (if "back" flag is set to false);
        function getTwoWeeks(date, back) {
            if (back)
                return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 14);
            else
                return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 14);
        }

        vm.back = function () {
            $state.go('tab-objects-dashboard',{
                firstAccess: false
            }, {notify: true, location: "replace"});
        };

        function setDayLess() {
            var to = new Date();
            var from = new Date();
            to.setHours(23, 59, 59, 999);
            from.setHours(0, 0, 0, 0);
            to.setDate(to.getDate() - 1 * vm.nextBtnDisabled);
            from.setDate(from.getDate() - 1 * vm.nextBtnDisabled);
            applyDate(from, to)
        };

        function setWeekDayLess() {
            var to = new Date();
            var from = new Date();
            to.setHours(23, 59, 59, 999);
            from.setHours(0, 0, 0, 0);
            to.setDate(to.getDate() - 7 * (vm.nextBtnDisabled + 1));
            from.setDate(from.getDate() - 7 * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };

        function setDaysLess(date) {
            var to = new Date();
            var from = new Date();
            to.setDate(to.getDate() - date * vm.nextBtnDisabled);
            from.setDate(from.getDate() - date * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };


        function setHoursLess(hour) {
            var to = new Date();
            var from = new Date();
            to.setHours(to.getHours() - hour * vm.nextBtnDisabled);
            from.setHours(from.getHours() - hour * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };

        function setMinutesLess(minutes) {
            var to = new Date();
            var from = new Date();
            to.setTime(to.getTime() - 60000 * minutes * vm.nextBtnDisabled);
            from.setTime(from.getTime() - 60000 * minutes * (vm.nextBtnDisabled + 1));
            applyDate(from, to)
        };

        function setWeekLess() {
            var to = new Date();
            var from = new Date();
            from.setDate(from.getDate() - 6 * vm.nextBtnDisabled - from.getDay() - vm.nextBtnDisabled + 1);
            to.setDate(to.getDate() - 6 * vm.nextBtnDisabled - to.getDay() - vm.nextBtnDisabled + 7);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999);
            applyDate(from, to)
        }

        function setMonthLess() {
            var to = new Date();
            var from = new Date();
            from.setMonth(from.getMonth() - vm.nextBtnDisabled);
            from.setDate(1);
            to.setMonth(to.getMonth() - vm.nextBtnDisabled + 1);
            to.setDate(0);
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999);
            applyDate(from, to)
        }

        function customTimeRange(sumOrDiff) {
            var to = angular.copy(vm.toDate);
            var from = angular.copy(vm.fromDate);
            to.setTime(to.getTime() + vm.rangeInMillis * sumOrDiff);
            from.setTime(from.getTime() + vm.rangeInMillis * sumOrDiff);
            applyDate(from, to);
        }

        vm.prev = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!vm.isCustomTimeRange) {
                vm.nextBtnDisabled = vm.nextBtnDisabled + 1;
                vm.columnChoose.setDate();
            } else {
                customTimeRange(-1);
                vm.nextBtnDisabled = 1;
            }
            vm.dashboardRange = vm.fromDate.toString().substring(0, vm.fromDate.toString().indexOf("GMT")) + " to " + vm.toDate.toString().substring(0, vm.toDate.toString().indexOf("GMT"));
            vm.isOpen = false;
        }

        vm.next = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!vm.isCustomTimeRange) {
                vm.nextBtnDisabled = vm.nextBtnDisabled - 1;
                if (vm.nextBtnDisabled === 0) {
                    vm.changeRange(vm.columnChoose);
                } else {
                    vm.columnChoose.setDate();
                }
            } else {
                customTimeRange(1);
                checkNext();
            }
            if (vm.nextBtnDisabled !== 0 || vm.isCustomTimeRange) {
                vm.dashboardRange = vm.fromDate.toString().substring(0, vm.fromDate.toString().indexOf("GMT")) + " to " + vm.toDate.toString().substring(0, vm.toDate.toString().indexOf("GMT"));
            }
            vm.isOpen = false;
        }

        function checkNext() {
            var now = new Date();
            vm.nextBtnDisabled = vm.toDate > now ? 0 : 1;
        }

    }
})();
